import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import addDays from 'date-fns/addDays';
import subDays from 'date-fns/subDays';
import parseISO from 'date-fns/parseISO';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import { MainImageThumbnail } from '../../../features/PpsiContainer/constants';
import TextField from '../../Form/Fields/TextField';
import SelectMultiField from '../../Form/Fields/SelectMultiField';
import FormulaVersionField from '../../Form/Fields/FormulaVersionField';
import SpacedTextField from '../../Form/Fields/SpacedTextField';
import DateField from '../../Form/Fields/DateField';
import FormContext from '../../Form/FormContext';
import SectionHeader from '../../Form/Fields/SectionHeader';
import ImageWithDropzone from '../../Image/ImageWithDropzone';
import { getIsGlobalUser } from '../../../features/loginSystem/selectors';
import {
  getLanguage,
  getConfigs,
  getMarketName
} from '../../../features/app/selectors';
import { isEqual } from 'lodash';
import useQueryParams from 'utils/useQueryParams';
import { Mode } from '../constants';
// import piaProductAreas from 'constants/piaProductAreas';
import { FranchiseType } from '../../../constants/franchiseType';
import {
  getMarketDishLogo,
  getPiaProductAreasNir,
  getPpsiById,
  getvaraintPpsis
} from 'features/PpsiContainer/selectors';
import { toJS } from 'utils/immutableUtils';
import ImageSelect from 'components/ImageSelect/ImageSelect';
import { getProductArea } from 'features/DishContainer/selectors';
import FilterButtonDropdown from 'components/Form/Fields/FilterButtonDropdown';

const useStyles = makeStyles(theme => ({
  mainImage: {
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4)
  }
}));

function toDate(date) {
  if (typeof date === 'string') {
    return parseISO(date);
  }
  return date;
}

const transformPiaProductAreas = piaProductAreas => {
  const grouped = {};
  if (!piaProductAreas.length) {
    return null;
  }
  piaProductAreas.forEach(item => {
    const headerKey = `${item.praNo} - ${item.praDescription}`;

    if (!grouped[headerKey]) {
      grouped[headerKey] = [];
    }

    grouped[headerKey].push({
      value: {
        piaProductArea: item.paNo,
        piaProductAreaName: item.paDescription,
        piaRangeArea: item.praNo,
        piaRangeAreaName: item.praDescription
      },
      label: `${item.paNo} - ${item.paDescription}`
    });
  });

  const result = Object.entries(grouped).map(([header, options]) => ({
    header,
    options
  }));

  return result;
};

const TextTabContent = ({ globalData, mode }) => {
  const classes = useStyles();
  const language = useSelector(getLanguage);
  const isGlobalUser = useSelector(getIsGlobalUser);
  const ppsi = useSelector(getvaraintPpsis);
  const { data, setFieldValue, getFieldValue } = useContext(FormContext);
  const { targetPublishDate, targetUnpublishDate, mainImage, dishLabel } = data;
  const dateFormat = useSelector(getConfigs).toJS().dateFormat || 'yyyy-MM-dd';
  const franchiseType = useSelector(getConfigs).toJS().franchise;
  const piaProductAreas = toJS(useSelector(getPiaProductAreasNir));
  // const piaProductAreas = transformPiaProductAreas(rawPiaProductAreas || []);

  const [fromPpsiId, fromEnrichmentId] = useQueryParams(
    'ppsiId',
    'enrichmentId'
  );

  const marketDishLogo = useSelector(getMarketDishLogo);
  const productArea = useSelector(getProductArea);

  const dishLogo = toJS(marketDishLogo);
  const productAreaList = toJS(productArea)
  const productAreaOptions = productAreaList.filter((item)=>item.isActive===true).map(p => ({
    value: p.code,
    label: p.info && p.info[language] && p.info[language].text
  }));
  let globalDishId;
  if (data && data.parentPpsiId) {
    globalDishId = data.parentPpsiId;
  } else if (ppsi && ppsi.inProgressPpsiEnrichmentData) {
    globalDishId = ppsi.inProgressPpsiEnrichmentData.parentPpsiId;
  } else {
    globalDishId = fromPpsiId;
  }
  // let dishGlobalId;

  const globalPpsi = useSelector(getPpsiById(globalDishId));
  const globalDishData = toJS(globalPpsi);

  function displayDates(data) {
    const isStatusPresent =
      data.status !== undefined && data.parentPpsiId !== undefined;
    if (isStatusPresent) {
      return !(
        (data.status === 'GLOBAL REJECTED' && data.parentPpsiId !== null) ||
        (data.status === 'DRAFT' && data.parentPpsiId !== null)
      );
    }
    if (data.dish !== undefined && data.dish.isGlobalBased === true) {
      return false;
    }
    return true;
  }

  // useEffect(() => {
  //   console.log(data, 'isShowRefresh');
  //   console.log(ppsi, 'ppsi');
  // }, [globalDishData]);
  const isCheckGlobalUpdate =
    data &&
    Array.isArray(data.updateNotificationList) &&
    data.updateNotificationList.length !== 0 &&
    data.updateNotificationList.category !== 'IFOOD_UPDATE';

  let isGlobalMainImage = true;
  if (
    (data && data.mainImage,
    globalDishData && globalDishData.publishedPpsiEnrichmentData.mainImage)
  ) {
    isGlobalMainImage = isEqual(
      data && data.mainImage,
      globalDishData && globalDishData.publishedPpsiEnrichmentData.mainImage
    );
  }

  // if((data && !data.mainImage) && (globalDishData && !globalDishData.publishedPpsiEnrichmentData.mainImage)){
  //   isGlobalMainImage = false
  // }
  if (
    !isEqual(
      data && data.mainImage,
      globalDishData && globalDishData.publishedPpsiEnrichmentData.mainImage
    )
  ) {
    isGlobalMainImage = false;
  }

  // console.log(
  //   data.mainImage,
  //   globalDishData && globalDishData.publishedPpsiEnrichmentData.mainImage
  // );
  let isDisableRefresh = isCheckGlobalUpdate || isGlobalMainImage; //(isGlobalMainImage && data.mainImage);

  const isShowRefresh =
    ((data && data.status === 'DRAFT') ||
      data.status === 'GLOBAL REJECTED' ||
      fromEnrichmentId !== undefined ||
      mode === Mode.CREATE) &&
    data &&
    data.parentPpsiEnrichmentDataId &&
    !isGlobalUser;

  function onChangeMainImage(imgData) {
    setFieldValue('mainImage', imgData);
  }
  function onChangeDishImage(imgData) {
    setFieldValue('dishLabel', imgData);
  }
  function onRefreshMainImage() {
    setFieldValue(
      'mainImage',
      globalDishData && globalDishData.publishedPpsiEnrichmentData.mainImage
    );
  }
  function getUnpublishMinDate() {
    if (targetPublishDate) {
      return addDays(toDate(targetPublishDate), 1);
    }
    return addDays(new Date(), 2);
  }

  function getPublishMinDate() {
    return addDays(new Date(), 1);
  }

  function getPublishMaxDate() {
    if (targetUnpublishDate) {
      return subDays(toDate(targetUnpublishDate), 1);
    }
    return null;
  }

  const getInitialProductArea = () => {
    if (!piaProductAreas.length || piaProductAreas === null) {
      return;
    }
    return piaProductAreas.reduce((acc, group) => {
      if (group.options) {
        const match = group.options.find(
          option =>
            option.value.piaProductArea === getFieldValue('dish.piaProductArea')
        );
        if (match) {
          return match.value;
        }
      }
      return acc;
    }, null);
  };
 function onChangeFilterButton(data) {
     setFieldValue('filterCode', data);
  }
  return (
    <Grid container spacing={4}>
      <Grid item sm={12} md={6}>
        <SectionHeader translationId="ppsi.dishInfoHeader" />
        <FormulaVersionField
          label="ppsi.iFoodIDLabel"
          dataField="dish.formulaCode"
          extentionField="dish.formulaVersion"
          disabled
        />
        <TextField
          label="ppsi.piaArticleNumber"
          dataField="dish.piaArticleNumber"
          disabled
        />
         <FilterButtonDropdown
            label="ppsi.filteringButton"
            dataField={`filterCode`}
            helperText="ppsi.filteringButtonHelperText"
            items={productAreaOptions}
            onSelectChange={onChangeFilterButton}
          />
          
        {/* {franchiseType !== FranchiseType.INGKA ? (
          <SelectMultiField
            label="ppsi.rangeCategoryLabel"
            dataField="dish.piaProductAreaName"
            items={piaProductAreas}
            helperText="ppsi.piaProductAreaHelperText"
            // initialValue={getInitialProductArea()}
            initialValue={getFieldValue('dish.piaProductArea') || ''}
            fieldProps="dish"
            disabled={false}
          />
        ) : (
          <TextField
            label="ppsi.rangeCategoryLabel"
            dataField="dish.piaProductAreaName"
            disabled
          />
        )} */}
        <TextField
          label="ppsi.presentationNameLabel"
          dataField={`info.${language}.presentationName`}
          helperText="ppsi.presentationNameHelperText"
        />
        <TextField
          label="ppsi.additionalInfoLabel"
          dataField={`info.${language}.additionalInformation`}
          helperText="ppsi.additionalInfoHelperText"
          multiline
          rows={3}
        />
        {displayDates(data) && (
          <SectionHeader translationId="ppsi.publishHeader" />
        )}
        {displayDates(data) && (
          <Grid container spacing={2}>
            <Grid item sm={12} md={6}>
              <DateField
                label="ppsi.publishDateLabel"
                dataField="targetPublishDate"
                minDate={getPublishMinDate()}
                maxDate={getPublishMaxDate()}
                dateFormat={dateFormat}
                helperText={
                  isGlobalUser
                    ? 'ppsi.publishDateHelperTextIFS'
                    : 'ppsi.publishDateHelperTextLocal'
                }
              />
            </Grid>
            <Grid item sm={12} md={6}>
              <DateField
                label="ppsi.unpublishDateLabel"
                dataField="targetUnpublishDate"
                minDate={getUnpublishMinDate()}
                dateFormat={dateFormat}
                helperText={
                  isGlobalUser
                    ? 'ppsi.unpublishDateHelperTextIFS'
                    : 'ppsi.unpublishDateHelperTextLocal'
                }
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <Grid item sm={12} md={6}>
        <SectionHeader
          translationId="ppsi.mainImageHeader"
          refreshIconShow={isShowRefresh}
          isDisable={isDisableRefresh}
          onRefreshMainImage={onRefreshMainImage}
        />
        <div className={classes.mainImage}>
          <ImageWithDropzone
            image={mainImage}
            thumbnailWidth={MainImageThumbnail.Width}
            thumbnailHeight={MainImageThumbnail.Height}
            onUploadImage={onChangeMainImage}
            size="large"
            dishLabel={dishLabel}
          />
          <FormHelperText variant="filled">
            <FormattedMessage id="ppsi.mainImageHelperText" />
          </FormHelperText>
        </div>
        {!isGlobalUser && (
          <Grid item sm={6} md={6} sx={{ pt: 2 }}>
            <ImageSelect
              onSelectImage={onChangeDishImage}
              dataField="dishLabel"
              dishLabel={dishLogo}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
export default TextTabContent;
